import React, { CSSProperties, FC } from 'react';

const commonStyle: CSSProperties = {
    color: 'white',
    width: 300,
    borderRadius: 5,
    height: 40,
    fontSize: 16,
    borderWidth: 0,
};

const activeStyle: CSSProperties = {
    cursor: 'pointer',
    backgroundColor: '#30ad82',
};

const disabledStyle: CSSProperties = {
    backgroundColor: 'gray',
};

const compactStyle: CSSProperties = {
    width: 80,
};

type Props = {
    label: string,
    onClick: any,
    disable?: boolean,
    compact?: boolean,
    style?: CSSProperties,
};
const Button: FC<Props> = ({ onClick, label, disable, compact, style }) => {
    let styles = commonStyle;
    if (disable) {
        styles = {
            ...styles,
            ...disabledStyle,
        };
    } else {
        styles = {
            ...styles,
            ...activeStyle,
        };
    }
    if (compact) {
        styles = {
            ...styles,
            ...compactStyle,
        };
    }
    if (style) {
        styles = {
            ...styles,
            ...style,
        };
    }
    return (
        <button
            disabled={disable}
            onClick={onClick}
            style={styles}
        >
            {label}
        </button>
    );
};

Button.defaultProps = {
    disable: false,
    compact: false,
};

export default Button;